export const getSecaoFromTab = (tab) => {
  const tabMap = {
    usuario: "Usuario",
    trem: "Trem",
  };

  return tabMap[tab];
};
